(function($){

    "use strict";

    function unique(array){
        return array.filter(function(el, index, arr) {
            return index == arr.indexOf(el);
        });
    }

    function sortProperties(obj){
        var sortable=[];
        for(var key in obj)
            if(obj.hasOwnProperty(key))
                sortable.push([key, obj[key]]);

        sortable.sort(function(a, b)
        {
            var x=a[1].toString().toLowerCase(),
                y=b[1].toString().toLowerCase();
            return x<y ? -1 : x>y ? 1 : 0;
        });
        return sortable;
    }

    function toggleAttribute($sel,change){

        if (change == false) {

            var winLocation  = decodeURIComponent(window.location.href);

            winLocation = winLocation.split("?").pop();
            winLocation = winLocation.split("&");

            var dataObj = {};

            for (var i = 0; i < winLocation.length; i++) {
                var property = winLocation[i].split("=");
                var key      = (property[0]);
                var value    = (property[1]);
                dataObj[key] = value;
            }

            if ($sel.attr('name') == 'category') {

                var cat = dataObj['product_cat'];

                if (cat) {

                    cat = cat.charAt(0).toUpperCase() + cat.slice(1);
                    cat = cat.replace('-',' ');

                    $('<span>'+cat+'</span>').appendTo($sel.closest('div.car-filter').next('div.atts-holder'));

                }
            }

            if (dataObj['filter_'+$sel.attr('name')]) {
                $('<span>'+dataObj['filter_'+$sel.attr('name')]+'</span>').appendTo($sel.closest('div.car-filter').next('div.atts-holder'));
            }

            return;

        } else {


            if ($sel.find('option').length > 1) {
                var selected = $sel.find('option:selected').attr('data-val');

                if (typeof(selected) != 'undefined' && selected != null && selected.length && change == true) {

                    $sel.closest('form[name="et-car-filter"]').addClass('loading');

                    if (jsonURL.indexOf('&pa_'+$sel.attr('name')) != -1) {

                        jsonURL = jsonURL.split("?");

                        var jsonURLStart = jsonURL[0]+'?';

                        jsonURL = jsonURL.pop();
                        jsonURL = jsonURL.split("&");

                        var dataObj = {};

                        for (var i = 0; i < jsonURL.length; i++) {
                            var property = jsonURL[i].split("=");
                            var key      = (property[0]);
                            var value    = (property[1]);
                            dataObj[key] = value;
                        }

                        if ('pa_'+$sel.attr('name') in dataObj) {
                            dataObj['pa_'+$sel.attr('name')] = selected;
                        }

                        var jsonURLArray = [];
                        var loop         = true;


                        $.each(dataObj, function( index, value ) {
                            if (loop) {
                                jsonURLArray.push(index+'='+value);
                                if (index == 'pa_'+$sel.attr('name')) {loop = false;}
                            }
                        });

                        jsonURLArray = jsonURLArray.join('&');
                        jsonURL = jsonURLStart+jsonURLArray;

                    } else {
                        jsonURL += '&pa_'+$sel.attr('name')+'='+selected;
                    }

                    $.ajax({
                        dataType: 'json',
                        url:jsonURL
                    })
                    .done(function(response){

                        var nextSel = $sel.parent().next().find('select');

                        if (typeof(nextSel) != 'undefined' && nextSel != null && nextSel.length) {

                            var output   = '';
                            var attrData = {};
                            var nextSelName = 'pa_'+nextSel.attr('name');

                            $sel.parent().nextAll().find('select').find('option').not('.default').remove();

                            $.each(response,function(index,object){

                                var attributes = object.product_attributes;

                                if (typeof(attributes) != 'undefined' && attributes != null) {
                                    $.each(attributes, function(index, value) {
                                        if (nextSelName == index) {
                                            $.each(value, function(index, value) {
                                                attrData[index] = value;
                                            });
                                        }
                                    });
                                }

                            });

                            if (typeof(attrData) != 'undefined' && attrData != null) {

                                attrData = sortProperties(attrData);

                                $.each(attrData, function(index, value) {
                                    output += '<option value="'+value[1]+'" data-val="'+value[0]+'">'+value[1]+'</option>';
                                });
                            }

                            if (output.length) {
                                nextSel.append(output);
                            }

                            setTimeout(function(){
                                $sel.closest('form[name="et-car-filter"]').removeClass('loading');
                            },500);
                        }


                    })
                    .fail(function(response){

                        $sel.closest('form[name="et-car-filter"]').removeClass('loading');

                        var message = opt.errorMessage;

                        alert(message);

                    });

                }

            }

        }
    }

    function toggleDefault($sel,change){

        if ($sel.find('option').length > 1) {
                var selected = $sel.find('option:selected').val();

                if (typeof(selected) != 'undefined' && selected != null && selected.length && change == true) {

                    $sel.closest('form[name="et-car-filter"]').addClass('loading');

                    if($sel.attr('name') != 'make') {
                        jsonURL = jsonURL.replace('product-model','product-trim');
                    } else {
                        jsonURL = jsonURLModel;
                    };

                    if (jsonURL.indexOf('&'+$sel.attr('name')) != -1) {

                        jsonURL = jsonURL.split("?");

                        var jsonURLStart = jsonURL[0]+'?';

                        jsonURL = jsonURL.pop();
                        jsonURL = jsonURL.split("&");

                        var dataObj = {};

                        for (var i = 0; i < jsonURL.length; i++) {
                            var property = jsonURL[i].split("=");
                            var key      = (property[0]);
                            var value    = (property[1]);
                            dataObj[key] = value;
                        }

                        if ($sel.attr('name') in dataObj) {
                            dataObj[$sel.attr('name')] = selected;
                        }

                        var jsonURLArray = [];
                        var loop         = true;


                        $.each(dataObj, function( index, value ) {
                            if (loop) {
                                jsonURLArray.push(index+'='+value);
                                if (index == $sel.attr('name')) {loop = false;}
                            }
                        });

                        jsonURLArray = jsonURLArray.join('&');
                        jsonURL = jsonURLStart+jsonURLArray;

                    } else {
                        jsonURL += '&'+$sel.attr('name')+'='+selected;
                    }

                    $.ajax({
                        dataType: 'json',
                        url:jsonURL
                    })
                    .done(function(response){

                        var nextSel = $sel.parent().next().find('select');

                        if (typeof(nextSel) != 'undefined' && nextSel != null && nextSel.length) {

                            var output   = '';
                            var attrData = {};
                            var nextSelName = nextSel.attr('name');

                            $sel.parent().nextAll().find('select').find('option').not('.default').remove();

                            $.each(response,function(index,object){

                                if (nextSelName == 'year') {
                                    attrData[object.year] = object.year;
                                } else {
                                    attrData[object.id] = object.name;
                                }

                            });

                            if (typeof(attrData) != 'undefined' && attrData != null) {

                                attrData = sortProperties(attrData);

                                if (attrData.length && attrData[0].length == 2 && attrData[0][0] == attrData[0][1]) {
                                    var years   = [];
                                    var objYear = attrData[0][0];

                                    if (objYear.includes('-')) {
                                        var period = objYear.split('-');
                                        for (var i=period[0]; i <= period[1]; i++) {
                                            years.push(i.toString());
                                        }
                                    // Comma used
                                    } else if (objYear.includes(',')) {
                                        var period = objYear.split(',');
                                        for (var i = 0; i < period.length; i++) {
                                            years.push(period[i].toString());
                                        }
                                    } else {
                                        years.push(objYear.toString());
                                    }

                                    years.sort();

                                    $.each(years, function(index, value) {
                                        output += '<option value="'+objYear+'">'+value+'</option>';
                                    });

                                } else {
                                    $.each(attrData, function(index, value) {
                                        output += '<option value="'+value[0]+'">'+value[1]+'</option>';
                                    });
                                }
                            }

                            if (output.length) {
                                nextSel.append(output);
                            }

                            setTimeout(function(){
                                $sel.closest('form[name="et-car-filter"]').removeClass('loading');
                            },500);
                        }


                    })
                    .fail(function(response){

                        $sel.closest('form[name="et-car-filter"]').removeClass('loading');

                        var message = opt.errorMessage;

                        alert(message);

                    });

                }

            }

    }

    var valid = "valid";

    function validateFilter(depth, filter){

        var make  = filter.find('select[name="make"]'),
            model = filter.find('select[name="model"]'),
            year  = filter.find('select[name="year"]'),
            trim  = filter.find('select[name="trim"]');

        var makeSelected  = make.find('option:selected').val(),
            modelSelected = model.find('option:selected').val(),
            yearSelected  = year.find('option:selected').val(),
            trimSelected  = trim.find('option:selected').val();

        var makeValid  = 'invalid',
            modelValid = 'invalid',
            yearValid  = 'invalid',
            trimValid  = 'invalid';

        switch(depth){
            case 'trim':
                if (!makeSelected.length || makeSelected == null)   {make.next('.alert').addClass('active');} else {makeValid  = 'valid'}
                if (!modelSelected.length || modelSelected == null) {model.next('.alert').addClass('active');} else {modelValid  = 'valid'}
                if (!yearSelected.length || yearSelected == null)   {year.next('.alert').addClass('active');} else {yearValid  = 'valid'}
                if (!trimSelected.length || trimSelected == null)   {trim.next('.alert').addClass('active');} else {trimValid  = 'valid'}

                if (makeValid == 'valid' && modelValid == 'valid' && yearValid == 'valid' && trimValid == 'valid') {
                    valid = "valid";
                }

            break;
            case 'model':
                if (!makeSelected.length || makeSelected == null)   {make.next('.alert').addClass('active');} else {makeValid  = 'valid'}
                if (!modelSelected.length || modelSelected == null) {model.next('.alert').addClass('active');} else {modelValid  = 'valid'}

                if (makeValid == 'valid' && modelValid == 'valid') {
                    valid = "valid";
                }

            break;
            case 'make':
                if (!makeSelected.length || makeSelected == null)   {make.next('.alert').addClass('active');} else {makeValid  = 'valid'}

                if (makeValid == 'valid') {
                    valid = "valid";
                }
            break;
        }
    }

    function createURL(shopURL, data){
        console.log('createURL', data);

        const currentUrl = window.location.href;

        const isShopPage = currentUrl.includes(opt.shop_slug_url) || currentUrl.includes(opt.category_slug_url);

        console.log(isShopPage);

        if (isShopPage) {
            const url = new URL(currentUrl);
            const searchParams = url.searchParams;

            if (data.make) {
                searchParams.set('make', data.make);
            }
            if (data.model) {
                searchParams.set( 'model', data.model );
            }

            window.location.assign(url.toString());
        }

        if (!isShopPage) {
            if (shopURL.indexOf("?") == -1){
                shopURL += '?';
            }

            $.each(data, function(key, value) {
                if (value.length) {
                    shopURL += '&'+key+'='+value;
                }
            });

            shopURL = encodeURI(shopURL);

            window.location.assign(shopURL);
        }
    }

    var $vinApiUrl = opt.vin_api_url;
    var $vinApiKey = '';
    var $vinApiID = '';
    var vin        = localStorage.getItem('vin');
    var current    = localStorage.getItem('currentCar');
    var $output    = '';
    var jsonURL = opt.jsonUrl;
        jsonURL += '?per_page=1000';

    var jsonURLModel = opt.jsonUrlModel;
        jsonURLModel += '?per_page=1000';

    var jsonURLTrim = opt.jsonUrlTrim;
        jsonURLTrim += '?per_page=1000';

    // Get API keys
    $.ajax({
        type: 'POST',
        url: opt.ajaxurl,
        data: {
            'action' : 'fetch_vin_api_key',
            'dataType': 'json'
        },
        success:function(data) {
            $vinApiKey = data.replace(/^"(.*)"$/, '$1');
        }
    });

    // Get API id
    $.ajax({
        type: 'POST',
        url: opt.ajaxurl,
        data: {
            'action' : 'fetch_vin_api_id',
            'dataType': 'json'
        },
        success:function(data) {
            $vinApiID = data.replace(/^"(.*)"$/, '$1');
        }
    });

    if (typeof(vin) != 'undefined' && vin != null) {
        vin = JSON.parse(vin);

        if (window.location.href.indexOf(vin['Make']) != -1){
            $output += '<div class="vin-result-wrapper"><ul class="vin-result et-clearfix">';

                $.each(vin,function(key, value){
                    if (typeof(value) != 'undefined' && value != null && value.length) {
                        $output += '<li>';
                            $output +='<span>'+key+':</span> '+value;
                        $output += '</li>';
                    }
                });

            $output += '</ul></div>';
        } else {
            localStorage.removeItem('vin');
        }

    }

    $('.widget_car_filter_widget').each(function(){
        var $this = $(this);

        var make             = $this.find('select[name="make"]'),
            makeSelect       =  make.find('option:selected').val(),
            depth            = 'trim',
            shopURL          = $this.find('.car-filter').data('shop');

        if ('' == make.find('option:selected').val()) {
            localStorage.removeItem('vin');
            $output = '';
        }

        if ($output.length) {$this.append($output);}

        if ($this.find('.car-filter').hasClass('depth-model')) {depth = 'model'} else
        if ($this.find('.car-filter').hasClass('depth-make')) {depth = 'make'}

        if ($this.find('.car-filter').hasClass('attributes-true')) {

            var attributesSelect = $this.find('select');
            var totalAttributes  = attributesSelect.length;
            var hierarchy        = $this.find('.car-filter').hasClass('hierarchy-true');

            attributesSelect.each(function(index, value){

                var $sel = $(this);

                toggleAttribute($sel,false);

                $sel.on('change',function(){
                    var $opt = $sel.find("option:selected").val();
                    if (index != totalAttributes - 1) {
                        if (hierarchy) {
                            toggleAttribute($(this),true);
                        }
                    }
                    if ('' !== $opt) {$sel.next('.alert').removeClass('active')}
                });

            });

        } else {

            jsonURL = jsonURLModel;

            var defaultSelect = $this.find('select');
            var totalDefaults = defaultSelect.length;

            defaultSelect.each(function(index, value){

                var $sel = $(this);

                toggleDefault($sel,false);

                $sel.on('change',function(){
                    var $opt = $sel.find("option:selected").val();
                    if (index != totalDefaults - 1) {
                        toggleDefault($(this),true);
                    }
                    if ('' !== $opt) {$sel.next('.alert').removeClass('active')}
                });

            });

        }

        $this.find('input[name="vin"]').on('focus',function(){
            $this.find('.example').addClass('active');
            $(this).next('.alert').removeClass('active');
        });

        $this.find('input[name="vin"]').on('focusout',function(){
            $this.find('.example').removeClass('active');
            $(this).next('.alert').removeClass('active');
        });

        $this.find('input[name="vin"]').on('keypress',function() {
            $this.find('.example').removeClass('active');
            $(this).next('.alert').removeClass('active');
        });

        $this.find('input[name="vin"]').on('paste',function() {
            $this.find('.example').removeClass('active');
            $(this).next('.alert').removeClass('active');
        });

        /* Local values
        ---------------*/

            if (typeof(current) != 'undefined' && current != null && current.length) {
                var currentCar = JSON.parse(current);

                if (currentCar['vin'] == 'undefined') {
                    $.each(currentCar, function(key, value) {
                    if (value.length) {
                        var select = $this.find('select[name="'+key+'"]');

                        if (key != 'make'){
                            if (key == "year") {
                                select.append('<option value="'+value+'" selected="selected">'+value+'</option>');
                            } else {
                                if (!value.startsWith(':')) {
                                    var data = value.split(':');
                                    if (data.length == 2) {
                                        select.append('<option value="'+data[0]+'" selected="selected">'+data[1]+'</option>');
                                    } else {
                                        select.append('<option value="'+data[0]+'" selected="selected">'+data[0]+'</option>');
                                    }
                                }
                            }
                        } else {
                            select.find('option:contains("'+value+'")').attr('selected','selected');
                            select.find('option[value="'+value+'"]').attr('selected','selected');
                        }
                    }
                });
                }
            }

        /* On submit
        ---------------*/

            $this.find('.car-filter-button').on('click',function(e){

                e.preventDefault();

                localStorage.removeItem('vin');

                var data = new Object;
                var car  = new Object;

                /* Check VIN
                ---------------*/

                var VIN = $this.find('input[name="vin"]').val();

                if (typeof($vinApiUrl) != 'undefined' && $vinApiUrl != null && typeof($vinApiKey) != 'undefined' && $vinApiKey != null && typeof(VIN) != 'undefined' && VIN.length && VIN != null) {

                    $this.find('.alert').removeClass('active');

                    var url = $vinApiUrl+'?format=json'+'&key='+$vinApiKey+'&vin='+VIN;

                    if($vinApiUrl.includes('vindecodervehicle')) {url = $vinApiUrl+'?id='+$vinApiID+'&key='+$vinApiKey+'&vin='+VIN;}
                    if($vinApiUrl.includes('marketcheck')) {url = $vinApiUrl+VIN+'/specs?api_key='+$vinApiKey;}

                    $.ajax({dataType: "json",url: url})
                    .done(function(response) {

                        var vinObject = new Object;

                        vinObject['Vin'] = VIN;

                        if ($vinApiUrl.includes('vindecodervehicle')) {

                            $.each(response['Results'][0],function(key, value){

                                var keyFormated = key.replace(/_/g, " ");

                                keyFormated = keyFormated.charAt(0).toUpperCase() + keyFormated.slice(1);
                                vinObject[keyFormated] = value;

                            });

                            data['make'] = vinObject['Make'];
                            car['make']  = vinObject['Make'];
                            data['vin'] = VIN;
                            car['vin'] = VIN;

                            switch(depth){
                                case 'model':
                                    data['model'] = vinObject['Model'];
                                    car['model'] = vinObject['Model'];
                                break;
                                case 'trim':
                                    data['model'] = vinObject['Model'];
                                    car['model'] = vinObject['Model'];
                                    data['yr']    = vinObject['ModelYear'];
                                    car['year']    = vinObject['ModelYear'];
                                    if (vinObject['Trim'].length) {
                                       data['trim']  = vinObject['Trim'];
                                       car['trim']  = vinObject['Trim'];
                                    }
                                break;
                            }

                            if (typeof(data['model']) == 'undefined' || data['model'] == null || !data['model'].length) {

                                url += '&getMoreData&AllCars';

                                $.ajax({dataType: "json",url: url,async: false})
                                .done(function(response) {
                                    if (response['data']) {

                                        var firstModel = '';

                                        $.each(response['data']['matchingModels'],function(key, value){
                                            firstModel = value[0];
                                        });

                                        data['model'] = firstModel['modelName'];
                                        car['model'] = firstModel['modelName'];
                                    }
                                });



                            }

                        } else if ($vinApiUrl.includes('marketcheck')) {

                            $.each(response,function(key, value){

                                var keyFormated = key.replace(/_/g, " ");

                                keyFormated = keyFormated.charAt(0).toUpperCase() + keyFormated.slice(1);

                                vinObject[keyFormated] = value;

                            });

                            data['make'] = vinObject['Make'];
                            car['make'] = vinObject['Make'];
                            data['vin'] = VIN;
                            car['vin'] = VIN;

                            switch(depth){
                                case 'model':
                                    data['model'] = vinObject['Model'];
                                    car['model'] = vinObject['Model'];
                                break;
                                case 'trim':
                                    data['model'] = vinObject['Model'];
                                    car['model'] = vinObject['Model'];
                                    data['yr']    = vinObject['Year'];
                                    car['year']    = vinObject['Year'];
                                    data['trim']  = vinObject['Engine'] + ' ' + vinObject['Trim'];
                                    car['trim']  = vinObject['Engine'] + ' ' + vinObject['Trim'];
                                    data['vin']   = vinObject['Vin'];
                                break;
                            }

                        } else {
                            if (response['success']) {
                                $.each(response['attributes'],function(key, value){

                                    var keyFormated = key.replace(/_/g, " ");

                                    keyFormated = keyFormated.charAt(0).toUpperCase() + keyFormated.slice(1);

                                    vinObject[keyFormated] = value;

                                });
                            } else {
                                $this.find('input[name="vin"]').next('.alert').addClass('active');
                            }

                            data['vin'] = VIN;
                            car['vin'] = VIN;
                            data['make'] = vinObject['Make'];
                            car['make'] = vinObject['Make'];

                            switch(depth){
                                case 'model':
                                    data['model'] = vinObject['Model'];
                                    car['model'] = vinObject['Model'];
                                break;
                                case 'trim':
                                    data['model'] = vinObject['Model'];
                                    car['model'] = vinObject['Model'];
                                    data['yr']    = vinObject['Year'];
                                    car['year']    = vinObject['Year'];
                                    data['trim']  = vinObject['Engine'] + ' ' + vinObject['Trim'];
                                    car['trim']  = vinObject['Engine'] + ' ' + vinObject['Trim'];
                                break;
                            }

                        }

                        localStorage.setItem('vin', JSON.stringify(vinObject));
                        localStorage.setItem('currentCar', JSON.stringify(car));

                        createURL(shopURL, data);

                    }).fail(function() {
                        alert("Check VIN API url or KEY!")
                    });


                } else {

                    if ($this.find('.car-filter').hasClass('attributes-true')) {

                        $this.find('.alert').removeClass('active');

                        attributesSelect.each(function(){

                            var $sel = $(this),
                                $opt = $sel.find('option:selected').val();

                            if (typeof($opt) != 'undefined' && $opt != null && $opt.length) {
                                if ($sel.attr('name') == "category") {
                                        data['product_cat'] = $opt;
                                } else {
                                    data['filter_'+$sel.attr('name')] = $opt;
                                }
                            }

                        });

                        if (!$.isEmptyObject(data)) {
                            createURL(shopURL, data);
                        } else {
                            attributesSelect.each(function(){
                                $(this).next('.alert').addClass('active');
                            });
                        }

                    } else {

                        $this.find('.alert').removeClass('active');

                        // validateFilter(depth, $this);

                        if (valid == "valid") {

                            data['make'] = $this.find('select[name="make"] option:selected').val();
                            car['make'] = $this.find('select[name="make"] option:selected').val();

                            switch(depth){
                                case 'model':
                                    data['model'] = $this.find('select[name="model"] option:selected').val();
                                    car['model'] = $this.find('select[name="model"] option:selected').val()+':'+$this.find('select[name="model"] option:selected').html();
                                break;
                                case 'trim':
                                    data['model'] = $this.find('select[name="model"] option:selected').val();
                                    car['model'] = $this.find('select[name="model"] option:selected').val()+':'+$this.find('select[name="model"] option:selected').html();
                                    data['yr']    = $this.find('select[name="year"] option:selected').val();
                                    car['year']    = $this.find('select[name="year"] option:selected').val();
                                    data['trim']  = $this.find('select[name="trim"] option:selected').val();
                                    car['trim'] = $this.find('select[name="trim"] option:selected').val()+':'+$this.find('select[name="trim"] option:selected').html();
                                break;
                            }


                            var current = localStorage.getItem('currentCar');

                            if (typeof(current) != 'undefined' && current != null && current.length) {
                                var currentCar = JSON.parse(current);
                                if (currentCar['vin']) {
                                    data['vin'] = currentCar['vin'];
                                }
                            }

                            localStorage.setItem('currentCar', JSON.stringify(car));

                            createURL(shopURL, data);
                        }

                    }
                }

            });

            $this.find('.reset').on('click',function(e){
                e.preventDefault();
                $this.find('select:not([name="make"]) option:not(.default)').remove();
                $this.find('select[name="make"]').find('.default').attr('selected','selected').siblings().removeAttr('selected');
                localStorage.removeItem('currentCar');

                $('.widget_product_categories a').each(function(){
                    var hrefDefault = $(this).attr('href');
                    if (hrefDefault.includes('?')) {
                        var newHref = hrefDefault.split('?');
                        $(this).attr('href',newHref[0]);
                    }
                });

            });

    });



})(jQuery);
